import { RouteObject } from 'react-router-dom';
import { lazy, Suspense } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const AnnualPlanPage = lazy(() => import('../pages/annual-plan/page'));
const ConsultationPage = lazy(() => import('../pages/consultation/page'));
const TestLinePage = lazy(() => import('../pages/test-line/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: (
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="text-lg">載入中...</div></div>}>
        <HomePage />
      </Suspense>
    ),
  },
  {
    path: '/annual-plan',
    element: (
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="text-lg">載入中...</div></div>}>
        <AnnualPlanPage />
      </Suspense>
    ),
  },
  {
    path: '/consultation',
    element: (
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="text-lg">載入中...</div></div>}>
        <ConsultationPage />
      </Suspense>
    ),
  },
  {
    path: '/test-line',
    element: (
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="text-lg">載入中...</div></div>}>
        <TestLinePage />
      </Suspense>
    ),
  },
  {
    path: '*',
    element: (
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="text-lg">載入中...</div></div>}>
        <NotFoundPage />
      </Suspense>
    ),
  },
];

export default routes;
